// Normal Weather 
export const MIST = 'Mist'
export const CLOUDY = 'Cloudy'
export const FAIR_DAY = 'Fair (Day)'
export const FOG = 'Fog'
export const FAIR_NIGHT = 'Fair (Night)'
export const FAIR_WARM = 'Fair & Warm'
export const SLIGHTLY_HAZY = 'Slightly Hazy'
export const PARTLY_CLOUDY_DAY = 'Partly_Cloudy (Day)'
export const PARTLY_CLOUDY_NIGHT = 'Partly_Cloudy (Night)'
export const WINDY_CLOUDY = 'Windy, Cloudy'
export const WINDY = 'Windy'
export const WINDY_FAIR = 'Windy, Fair'
export const OVERCAST = 'Overcast'
export const HAZY = 'HAZY'
export const SUNNY = 'Sunny'
export const STRONG_WINDS = 'Strong Winds'

// Rain without Thunder
export const HEAVY_RAIN = 'Heavy Rain'
export const HEAVY_SHOWERS = 'Heavy Showers'
export const LIGHT_RAIN = 'Light Rain'
export const LIGHT_SHOWERS = 'Light Showers'
export const SHOWERS = 'Showers'
export const STRONG_WINDS_SHOWERS = 'Strong Winds, Showers'
export const PASSING_SHOWERS = 'Passing Showers'
export const MODERATE_RAIN = 'Moderate Rain'
export const STRONG_WINDS_RAIN = 'Strong_Winds, Rain'
export const SNOW_SHOWERS = 'Snow Showers'
export const WINDY_RAIN = 'Windy, Rain'
export const WINDY_SHOWERS = 'Windy, Showers'

// Rain with Thunders
export const HEAVY_THUNDERY_SHOWERS_WITH_GUSTY_WINDS = 'Heavy Thundery Showers with Gusty Winds'
export const HEAVY_THUNDERY_SHOWERS = 'Heavy Thundery Showers'
export const THUNDER_SHOWERS = 'Thundery Showers'


export const SNOW = 'Snow'